// extracted by mini-css-extract-plugin
export default {"wrapper":"ProPageCommon_wrapper__DLn9k","wrapperColumn":"ProPageCommon_wrapperColumn__qMhAM","header":"ProPageCommon_header__JZCZz"};